import { computed } from 'vue'

export default {
    name: 'NykButton',
    props: {
        // Determines whether to render as button or link
        as: {
            type: String,
            default: 'button',
            validator: v => ['button', 'link'].includes(v)
        },
        // Link-specific props
        href: {
            type: String,
            default: ''
        },
        target: {
            type: String,
            default: '_self'
        },
        // Button/Link appearance
        variant: {
            type: String,
            default: 'default',
            validator: v => [
                'default', 'neutral', 'filled-primary', 'filled-primary-dark', 'outline', 'primary-outline', 'hyperlink', 'hyperlink-neutral', 'accent'
            ].includes(v)
        },
        shape: {
            type: String,
            default: 'default',
            validator: v => ['default', 'round', 'square'].includes(v)
        },
        alignItems: {
            type: String,
            default: 'space-around',
            validator: v => ['space-around', 'space-between'].includes(v)
        },
        justifyContent: {
            type: String,
            default: 'center',
            validator: v => ['start', 'center', 'end'].includes(v)
        },
        ariaLabel: {
            type: String,
            default: ''
        },
        ariaDescribedby: {
            type: String,
            default: ''
        },
        autofocus: {
            type: Boolean,
            default: false
        },
        customClass: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        // Icon animation on hover
        animateIcon: {
            type: Boolean,
            default: false
        },
        // Button type (only used when as='button')
        type: {
            type: String,
            default: 'button'
        }
    },
    emits: ['click', 'keydown'],
    setup(props, { emit }) {
        const componentTag = computed(() => {
            return props.as === 'link' ? 'a' : 'button'
        })

        const handleClick = event => {
            if (props.disabled) {
                if (props.as === 'link') event.preventDefault()
                return
            }
            emit('click', event)
        }

        const handleKeydown = event => {
            if (!props.disabled) emit('keydown', event)
        }

        const buttonClasses = computed(() => {
            const classes = [
                'nyk-generic-button',
                `nyk-generic-button--${props.variant}`,
                `nyk-generic-button--${props.shape}`
            ];

            if (props.justifyContent !== 'center') {
                classes.push(`nyk-generic-button--justify-${props.justifyContent}`);
            }

            if (props.alignItems !== 'space-around') {
                classes.push(`nyk-generic-button--align-${props.alignItems}`);
            }

            if (props.animateIcon) {
                classes.push('nyk-generic-button--animate-icon');
            }

            if (props.customClass) {
                classes.push(props.customClass);
            }

            return classes.join(' ');
        });

        return {
            componentTag,
            handleClick,
            handleKeydown,
            buttonClasses
        }
    }
}
